import React, { useEffect, useState } from 'react';
import axios from 'axios';
import CheckList from '../components/CheckList';
import { useMsal } from "@azure/msal-react";
import useStore from '../useStore';
import { Container } from "react-bootstrap";

function LoadingIndicator() {
  return (
    <div className="loading-container">
      <div className="spinner"></div>
      <div className="loading-label">Loading</div>
    </div>
  );
}

function Payments() {
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const [profileData, setProfileData] = useState(null);
  const userEmail = useStore((state) => state.userEmail);
  const setUserEmail = useStore((state) => state.setUserEmail);
  //const selectedAgency = useStore((state) => state.selectedAgency);
  const { selectedAgency } = useStore();
  const setSelectedAgency = useStore((state) => state.setSelectedAgency);
  const resetSelectedAgency = useStore((state) => state.resetSelectedAgency);
  const [loading, setLoading] = useState(true);
  const [agencies, setAgencies] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (activeAccount && !profileData) {
      setProfileData(activeAccount.idTokenClaims);
      const emails = activeAccount.idTokenClaims.emails;
      if (emails && emails.length > 0) {
        const email = emails[0];
        console.log('Email captured in ProfileDetails:', email);
        if (!userEmail) {
          setUserEmail(email);
        }
      } else {
        console.error('No email found in idTokenClaims');
      }
    }
  }, [activeAccount, profileData, setUserEmail, userEmail]);

  useEffect(() => {
    if (!userEmail) return; // wait until we have an email

    // if an agency is already selected (e.g., from navbar)
    if (selectedAgency) {
      setLoading(false);
      return;
    }

    // otherwise, look up the agency via API
    setLoading(true);
    axios.get(`${process.env.REACT_APP_API_URL}/Agencies?email=${userEmail}`)
      .then((response) => {
        const agenciesData = response.data || [];

        // handle "no agency found"
        if (agenciesData.length === 0) {
          setError("No agencies found for this email.");
        } else {
          setAgencies(agenciesData);
          // if only one, select automatically
          if (agenciesData.length === 1) {
            setSelectedAgency(agenciesData[0]);
          }
        }
      })
      .catch((error) => {
        if (error.response) {
          console.log('Response error:', error.response.data);
          setError(error.response.data);
        } else if (error.request) {
          console.log('Request error:', error.request);
          setError('No response received from server');
        } else {
          console.log('General error:', error.message);
          setError(error.message);
        }
      })
      .finally(() => setLoading(false));
  }, [userEmail, selectedAgency, setSelectedAgency]);

  if (loading) return <LoadingIndicator />;
  if (error) return <div>Error: {typeof error === 'string' ? error : error.message}</div>;

  const handleAgencyClick = (agency) => {
    setSelectedAgency(agency);
  };

  return (
    <Container>
      {selectedAgency ? (
        <CheckList agency={selectedAgency} onBack={resetSelectedAgency} />
      ) : (
        <div>
          <h2>Select an Agency</h2>
          <ul className="agency-list">
            {agencies.map(agency => (
              <li
                key={agency.vendorId}
                onClick={() => handleAgencyClick(agency)}
                className="agency-item"
              >
                {agency.name} ({agency.vendorId})
              </li>
            ))}
          </ul>
        </div>
      )}
    </Container>
  );
}

export default Payments;